import PersonAddAltOutlinedIcon from '@mui/icons-material/PersonAddAltOutlined';
import {
  CardActions,
  Typography,
  CardContent,
  Avatar,
  Card,
  Button,
  Link,
  MenuItem,
  MenuList,
  type Theme,
} from '@mui/material';
import Grid from '@mui/material/Grid';

import type { GetUserQuery } from '../../../../gql/graphql';

type UserMenuCardProps = {
  data: GetUserQuery | undefined;
  handleLogout: () => void;
  handleLogin: () => void;
};

export const UserMenuCard = (props: UserMenuCardProps) => {
  return props.data ? (
    <Card sx={{ width: 320 }}>
      <CardActions sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography variant="body2" color="text.secondary">
          Morgan, Lewis & Bockius LLP
        </Typography>
        <Button size="small" color="inherit" onClick={() => props.handleLogout()} sx={{ textTransform: 'none' }}>
          Sign Out
        </Button>
      </CardActions>
      <CardContent>
        <Grid container spacing={2}>
          <Grid size="auto">
            <Avatar
              alt={props.data?.me?.displayName || 'User'}
              src={props.data?.me?.images?.medium || '/static/avatar.jpg'}
              sx={{ width: 88, height: 88, mr: 2 }}
            />
          </Grid>
          <Grid size="grow">
            <Typography variant="h6" noWrap>
              {props.data?.me?.displayName}
            </Typography>
            <Typography
              variant="body2"
              color="text.secondary"
              noWrap
              sx={{ display: 'block', textOverflow: 'ellipsis' }}
            >
              {props.data?.me?.mail}
            </Typography>
            <Typography
              variant="body2"
              component="div"
              sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
            >
              <Link
                href="https://myaccount.microsoft.com/?ref=MeControl"
                target="_blank"
                sx={(theme: Theme) => ({
                  color: theme.palette.mode === 'dark' ? theme.palette.secondary.main : theme.palette.primary.main,
                })}
              >
                View account
              </Link>
            </Typography>
            <Typography
              variant="body2"
              component="div"
              sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
            >
              <Link
                href={`https://mlprod.sharepoint.com/sites/MNPeople/SitePages/People.aspx?email=${props.data?.me?.mail}`}
                target="_blank"
                sx={(theme: Theme) => ({
                  color: theme.palette.mode === 'dark' ? theme.palette.secondary.main : theme.palette.primary.main,
                })}
              >
                My profile
              </Link>
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
      <CardActions
        sx={(theme) => ({
          color: theme.palette.mode === 'dark' ? theme.palette.secondary.main : theme.palette.primary.main,
        })}
      >
        <Button
          size="small"
          color="inherit"
          sx={{ textTransform: 'none' }}
          fullWidth
          onClick={() => props.handleLogin()}
          startIcon={<PersonAddAltOutlinedIcon fontSize="large" />}
        >
          Sign in with a different account
        </Button>
      </CardActions>
    </Card>
  ) : (
    <MenuList>
      <MenuItem onClick={() => props.handleLogin()}>Sign in</MenuItem>
    </MenuList>
  );
};
